<template>
  <div class="routing-list">
    <transition name="slide-up">
      <div class="infinity-loader" v-show="scrollLoading && !forDispatch">
        <i class="fas fa-spinner fa-spin"></i> Loading
      </div>
    </transition>
    <div class="table-container" v-show="!isLoading && items.length > 0">
      <transition name="slide-up">
         <div class="infinity-loader" v-show="scrollLoading && forDispatch">
           <i class="fas fa-spinner fa-spin"></i> Loading
         </div>
       </transition>

      <div class="select-filter" v-if="isMobile">
        <div :class="'pkg-id sortable' + (isSorting ? ' disabled': '')" @click="sort('p.ID')">
          <span>ID</span>
          <span v-show="packageSort.order === 'p.id'">
            <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
            <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
            <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
          </span>
        </div>
        <div :class="'pkg-pickup-time sortable' + (isSorting ? ' disabled': '')" @click="sort('p.pickupTime')">
          <span>Pickup Time</span>
          <span v-show="packageSort.order === 'p.pickupTime'">
            <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
            <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
            <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
          </span>
        </div>
      </div>

      <table v-show="isMobile ? !isSorting : true">
        <thead class="fixed-header" v-if="!isMobile">
          <drag tag="tr" class="table-header">
            <th class="pkg-chk"><input type="checkbox" v-model="checkedAll" /></th>
            <th v-bind:class="'pkg-id sortable' + (isSorting ? ' disabled': '')" @click="sort('p.id')">
              <span>ID</span>
              <span v-show="packageSort.order === 'p.id'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th class="pkg-status">STATUS</th>
            <th v-bind:class="'pkg-pickup-time sortable' + (isSorting ? ' disabled': '')" @click="sort('p.pickupTime')">
              <span>PICKUP TIME</span>
              <span v-show="packageSort.order === 'p.pickupTime'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'pkg-pickup sortable' + (isSorting ? ' disabled': '')" @click="sort('p.firstPickup')">
              <span>FIRST PICKUP</span>
              <span v-show="packageSort.order === 'p.firstPickup'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <!--th v-bind:class="'sortable' + (isSorting ? ' disabled': '')" @click="sort('p.lastPickup')">
              <span>LAST PICKUP</span>
              <span v-show="packageSort.order === 'p.lastPickup'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th-->
            <th class="pkg-dropoff">LAST DROP-OFF</th>
            <th class="pkg-service">SERVICE</th>
            <th class="pkg-driver">DRIVER</th>
            <th class="pkg-payment">PAYMENT</th>
            <th class="pkg-ada">ADA</th>
            <th v-bind:class="'pkg-stops sortable' + (isSorting ? ' disabled': '')" @click="sort('p.stops')">
              <span>STOPS</span>
              <span v-show="packageSort.order === 'p.stops'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'pkg-pax sortable' + (isSorting ? ' disabled': '')" @click="sort('p.pax')">
              <span>PAX</span>
              <span v-show="packageSort.order === 'p.pax'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th class="pkg-luggage">LUGGAGE</th>
            <th v-bind:class="'pkg-in-pool sortable' + (isSorting ? ' disabled': '')" @click="sort('p.inPool')">
              <span>IN POOL</span>
              <span v-show="packageSort.order === 'p.inPool'">
                <i class="fas fa-caret-up" v-show="packageSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!packageSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th class="pkg-map"></th>
          </drag>
        </thead>
        <tbody>
          <package-row v-for="(opPackage, index) in items" :opPackage="opPackage" :key="index" :forDispatch="forDispatch" :isMobile="isMobile"></package-row>
        </tbody>
      </table>

      <!-- <div v-bind:class="{ paging: true, disabled: isPageLoading }"
            v-show="totalPages > 1">
        <a v-bind:class="{
             'page page-btn back': true,
             disabled: currentPage === 1
          }" href="javascript:;" @click="pageBtn(false)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-left': !isLoadingBack,
            'fa-spinner fa-spin': isLoadingBack
          }"></i>
        </a>
        <select class="page page-number" v-model.number="currentPage" @change="loadPage">
          <option v-for="n in totalPages" :value="n">{{ n }}</option>
        </select>
        <a v-bind:class="{
             'page page-btn next': true,
             disabled: currentPage === totalPages
          }" href="javascript:;" @click="pageBtn(true)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-right': !isLoadingNext,
            'fa-spinner fa-spin': isLoadingNext
          }"></i>
        </a>
      </div> -->
    </div>

    <div class="empty-reservations" v-show="items.length <= 0 && !isLoading">
      <arrow-up></arrow-up>
      <div class="title">Oops. Looks like we found nothing.</div>
      <div class="content">
        We can't find any reservations or package for that filter.<br/>
        Please use another one from the form at the top.
      </div>
    </div>

    <div class="table-loader" v-show="isLoading">
      <ellipsis-loader></ellipsis-loader>
      <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
      <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
    </div>
  </div>
</template>

<script>
import ArrowUp from '@/components/Partials/LoadingAnimation/ArrowUp'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import PackageRow from './PackageRow'
import ApiRoutingReservation from '@/modules/api/routing/reservations'

export default {
  name: 'routing-list',
  components: { ArrowUp, EllipsisLoader, PackageRow },
  props: [ 'forDispatch', 'isMobile' ],
  data () {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false
    }
  },
  computed: {
    items () { return this.$store.state.routing.packages.items },
    isLoading () { return this.$store.state.routing.packages.isLoading },
    totalPages () { return this.$store.state.routing.packages.paging.totalPages },
    currentPage: {
      get () { return this.$store.state.routing.packages.paging.currentPage },
      set (value) { this.$store.commit('routing/setPackageCurrentPage', value) }
    },
    packageSort () { return this.$store.state.routing.packages.sort },
    checkedAll: {
      get () {
        if (this.forDispatch) {
          return this.$store.state.routing.packages.items.length ===
                 this.$store.state.routing.packages.checkedForDispatch.length
        }
        return this.$store.state.routing.packages.items.length ===
               this.$store.state.routing.packages.checked.length
      },
      set (value) {
        let self = this
        let packages = self.$store.state.routing.packages.items
        let checkedItems = []
        if (value) {
          for (let i = 0; i < packages.length; i++) {
            checkedItems.push(packages[i].id)
          }
        }
        if (self.forDispatch) {
          self.$store.commit('routing/updateCheckedPackagesForDispatch', checkedItems)
        } else {
          self.$store.commit('routing/updateCheckedPackages', checkedItems)
        }
      }
    }
  },
  methods: {
    pageBtn (isNext) {
      let self = this
      let pageChange = isNext ? 1 : -1
      if (isNext) {
        self.isLoadingNext = true
      } else {
        self.isLoadingBack = true
      }
      self.$store.commit('routing/setPackageCurrentPage',
        self.$store.state.routing.packages.paging.currentPage + pageChange)
      self.loadPage()
    },
    loadPage () {
      let self = this
      // self.isPageLoading = true
      ApiRoutingReservation.getPackages(self, r => {
        // self.isPageLoading = false
        self.isLoadingBack = false
        self.isLoadingNext = false
        self.scrollLoading = false

        if (r.error) {
          return
        }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('routing-packages-table'))
      }, true)
    },
    sort (order) {
      let self = this
      let existingOrder = self.packageSort.order
      let existingAsc = self.packageSort.asc
      let asc = existingAsc
      if (order === existingOrder) {
        asc = !existingAsc
      }

      self.$store.commit('routing/setPackagesSort', {
        order: order, asc: asc
      })

      self.isSorting = true
      self.$store.commit('routing/setPackageCurrentPage', 1)
      ApiRoutingReservation.getPackages(self, r => {
        self.isSorting = false
        if (r.error) {
          return
        }
      }, true)
    },
    onScroll () {
      let rsvpPaging = this.$store.state.routing.packages.paging
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) { return }

      this.scrollLoading = true
      this.$store.commit('routing/setPackageCurrentPage', rsvpPaging.currentPage + 1)
      this.loadPage()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';

.routing-list{ position: relative; }
.table-container {
  padding: 47px 0 0;
  position: relative;
  & input[type="checkbox"]{
    margin-top: 0;
    width: auto;
  }
  & table{
    border-collapse: collapse;
    width: 100%;
  }

  .fixed-header{
    position: absolute;
    top: 0;
  }
  & .table-header{
    color: #8DA0A9;
    font-size: 12px;
    /*border: 1px solid rgba(0,0,0,0.3);*/
    background-color: #f5f5f5;

    & th{
      padding: 5px;


      &.sortable {
        cursor: pointer;
        text-decoration: underline;
        color: #333;
        transition: all 250ms;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
      &.pkg-chk{ width: 24px!important; }
      &.pkg-id{ width: 52px!important; }
      &.pkg-status{ width: 90px!important; }
      &.pkg-pickup-time{ width: 80px!important; }
      &.pkg-pickup, &.pkg-dropoff{ width: 140px!important; }
      &.pkg-driver{ width: 86px!important; }
      &.pkg-payment{ width: 65px!important; }
      &.pkg-ada{ width: 50px!important; }
      &.pkg-stops{ width: 47px!important; }
      &.pkg-pax{ width: 32px!important; }
      &.pkg-luggage{ width: 66px!important; }
      &.pkg-in-pool{ width: 43px!important; }
      &.pkg-map{ width: 64px!important; }
    }
  }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

.table-loader{
  position: relative;
  width: 300px;
  margin: 50px auto;
  text-align: center;

  & .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}


.paging {
  margin: 15px auto;
  width: 103px;
  opacity: 1;
  transition: all 250ms;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  & .page{
    display: inline-block;
    vertical-align: middle;
    width: auto;

    &:not(:first-child) {
      margin-left: -5px;
    }
  }

  & .page-btn {
    background-color: #f5f5f5;
    border: 1px solid rgba(0,0,0,0.25);
    color: #777;
    padding: 5px 5px;
    font-size: 12px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    & i { line-height: inherit; }

    &.back {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      border-right: 0;
    }

    &.next {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  & .page-number {
    border-radius: 0;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.3);
    line-height: inherit;
    font-size: 12px;
    margin: 0;
    width: 50px;
    font-weight: 700;
    padding: 5px 10px;
    color: #333;
    text-align: center;
    appearance: none;
    outline: 0;
    text-align-last:center;
    border-right: 0;
  }
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
  z-index: 2;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .select-filter {
    display: flex;
    margin: 0 10px;
    justify-content: center;
    .sortable {
      border: 1px solid #ccc;
      padding: 5px 20px;
      font-size: 12px;
      font-weight: 900;
      text-transform: uppercase; 
      width: 50%;
      text-align: center;
      background-color: #fff;
    }
  }

  .table-container {
    padding-top: 10px;
    padding-bottom: 50px;
  }

  .empty-reservations {
    padding: 0 10px;
    .title {
      font-size: 18px;
    }
    .content {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/PackagesTable.vue